import { useEffect } from "react";

export function useExposeFetchFirstPage(fetchFirstPage: () => Promise<void>) {
  useEffect(() => {
    (window as any).gwFetchFirstPage = fetchFirstPage;
    return () => {
      if ((window as any).gwFetchFirstPage === fetchFirstPage) {
        delete (window as any).gwFetchFirstPage;
      }
    };
  }, [fetchFirstPage]);
}
